<artemis-breadcrumbs [breadcrumbs]="breadcrumbs"></artemis-breadcrumbs>
<artemis-customer-overview-card></artemis-customer-overview-card>
<div class="add-crp-card" id="addCrpCard">
  <div ubi-curve-header class="add-crp-card__header">
    <span class="add-crp-card__header-text"> {{ 'crp.add.header' | translate }} </span>
  </div>
  <artemis-popover>
    <ng-container *ngFor="let section of ('crp.add.info.content' | translate)">
      <ng-container *ngFor="let content of section.paragraph">
        <p>{{content}}</p>
      </ng-container>
    </ng-container>
  </artemis-popover>
  <div class="add-crp-card__content-container">
    <artemis-loading-spinner *ngIf="(loading$ | async) || formLoading"></artemis-loading-spinner>
    <div class="add-crp-card__subsection">
      <artemis-details-form [detailFormOption]="detailFormOption" [isPrimary]="false" (formDataChanged)="formChange($event)" [isSearch]="true" (loading)="formLoadingHandler($event)">
      </artemis-details-form>
    </div>
    <div class="add-crp-card__subsection">
      <artemis-crp-role></artemis-crp-role>
      <div class="add-crp-card__btns-container">
        <div class="add-crp-card__msg-container">
          <div class="add-crp-card__hint-msg">
            <div *ngIf="hasFormerOrAliasName()"> {{ 'customer_info.message.alias_or_former_name_credit_consumption' | translate }} </div>
          </div>
          <div class="add-crp-card__error-msg" [hidden]="!triedSubmit">
            <div [hidden]="isFormValid()">{{ 'crp.add.message.form_valid' | translate }}</div>
            <div [hidden]="isRoleProvided()">{{ 'crp.add.message.role_provided' | translate }}</div>
          </div>
        </div>
        <button class="btn btn_rounded add-crp-card__submit-btn" mat-button ubi-round-button (click)="updateCustomer()">
          {{ 'crp.button.save_as_draft' | translate }}
        </button>
        <button class="btn btn_accent-gradient-rounded add-crp-card__submit-btn" mat-button ubi-round-button (click)="updateCustomer('crp')">
          {{ 'crp.button.save_and_add_another_crp' | translate }}
        </button>
        <button class="btn btn_accent-gradient-rounded add-crp-card__submit-btn" mat-button ubi-round-button (click)="updateCustomer('ra')">
          {{ 'crp.button.complete_and_submit_for_screening' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
